module.exports = __webpack_public_path__ + "media/images/new-48-green-9b2a174cb71f73321e0aa93cad81c2cb.png";